'use strict';

exports.__esModule = true;
exports.getEnvName = exports.setDebug = exports.isTest = exports.isProduction = exports.isDevelopment = exports.isDebug = undefined;

var _browser = require('./browser');

var _string = require('./string');

var isDevelopment = function isDevelopment(dlOverride) {
  var hostName = (0, _browser.getBaseHost)(dlOverride);
  return !hostName || (0, _string.startsWith)(hostName, 'dev-') || (0, _string.startsWith)(hostName, 'localhost');
};

var isTest = function isTest(dlOverride) {
  var hostName = (0, _browser.getBaseHost)(dlOverride);
  return (0, _string.startsWith)(hostName, 'test-') || (0, _string.startsWith)(hostName, 'stg-');
};

var isProduction = function isProduction() {
  return !isDevelopment() && !isTest();
};

var getEnvName = function getEnvName() {
  if (isTest()) {
    return 'test';
  } else if (isProduction()) {
    return 'prod';
  }
  return 'dev';
};

var _isDebug = false;

var isDebug = function isDebug() {
  return _isDebug;
};

var setDebug = function setDebug(debug) {
  _isDebug = debug === true || debug === 'true';
};

exports.isDebug = isDebug;
exports.isDevelopment = isDevelopment;
exports.isProduction = isProduction;
exports.isTest = isTest;
exports.setDebug = setDebug;
exports.getEnvName = getEnvName;